const handleExpand = function($) {
  $(".category-products").each(function() {
    const normalizeProductHeight = () => {
      let tallestProductHeight = -1;
      $(this).find('.product').each(function() {
        $(this).css({height: 'auto'});
        const h = $(this).height();
        if (h > tallestProductHeight) tallestProductHeight = h;
      }).each(function() {
        $(this).height(tallestProductHeight);
      });
    }
    normalizeProductHeight();


    const toggleHeight = (open=false) => {
      // console.log([this, this.scrollHeight]);
      $(this).toggleClass('open', open).css({maxHeight: open ? this.scrollHeight : $(this).find(".product").outerHeight(true)});
    }

    const toggleButtonVisibility = () => {
      // if ($(this).find(".product").outerHeight(true) == this.scrollHeight) {
      //   $(this).siblings(".product-expand").children().css({opacity: 0, pointerEvents:"none"});
      // } else {
      //   $(this).siblings(".product-expand").children().css({opacity: 1, pointerEvents:"all"});
      // }

      $(".category").each(function () {
        if (window.innerWidth > 768) {
          if ($(this).find(".product").length < 5) {
            $(this).find(".product-expand").children().css({opacity: 0, pointerEvents:"none"});
            console.log("window.innerWidth > 768 if");
          } else {
            $(this).find(".product-expand").children().css({opacity: 1, pointerEvents:"auto"});
            console.log("window.innerWidth > 768 else");
          }
        }
        if (window.innerWidth < 768 && window.innerWidth > 625) {
          if ($(this).find(".product").length < 4) {
            $(this).find(".product-expand").children().css({opacity: 0, pointerEvents:"none"});
            console.log("window.innerWidth < 768 && window.innerWidth > 625 if");
          } else {
            $(this).find(".product-expand").children().css({opacity: 1, pointerEvents:"auto"});
            console.log("window.innerWidth < 768 && window.innerWidth > 625 else");
          }
        }
        if (window.innerWidth < 626) {
          if ($(this).find(".product").length < 2) {
            $(this).find(".product-expand").children().css({opacity: 0, pointerEvents:"none"});
            console.log("window.innerWidth < 626 if");
          } else {
            $(this).find(".product-expand").children().css({opacity: 1, pointerEvents:"auto"});
            console.log("window.innerWidth < 626 else");
          }
        }
      });
    }

    setTimeout(() => toggleHeight(), 10);
    setTimeout(() => toggleButtonVisibility(), 10);

    $(this)
      .siblings(".product-expand")
      .find("button")
      .click(e => {
        const $product_expand = $(e.currentTarget).parent(".product-expand");
        $product_expand.toggleClass("open");
        toggleHeight($product_expand.hasClass("open"));
      });

    const adjustProducts = () => {
      normalizeProductHeight();
      $(this).css({maxHeight: $(this).hasClass('open') ? this.scrollHeight : $(this).find(".product").outerHeight(true)});
      toggleButtonVisibility();
    }
    $(window).on('resize', function () {
      adjustProducts();

      $(".category").each(function () {
        if (window.innerWidth > 768) {
          if ($(this).find(".product").length < 5) {
            $(this).find(".product-expand").children().css({opacity: 0, pointerEvents:"none"});
          }
        }
        if (window.innerWidth < 768 && window.innerWidth > 625) {
          if ($(this).find(".product").length < 3) {
            $(this).find(".product-expand").children().css({opacity: 0, pointerEvents:"none"});
          }
        }
        if (window.innerWidth < 626) {
          if ($(this).find(".product").length < 2) {
            $(this).find(".product-expand").children().css({opacity: 0, pointerEvents:"none"});
          }
        }
      });

    });
    setTimeout(adjustProducts, 200);
  });
};

exports.init = function($) {
  handleExpand($);
}
 